import { useCallback } from "react";
import { useSettings } from "_contexts/useSettings";
import {
  sendGTMEvent,
  trackFormSubmit,
  trackButtonClick,
  trackError,
} from "_helpers/gtm";

/**
 * Hook that provides GTM tracking functions.
 * All functions are no-ops if the self-enrollment has no gtm_id configured.
 */
export const useGTM = () => {
  const { settings } = useSettings();
  const enabled = !!settings?.gtm_id;

  const gtmEvent = useCallback(
    (eventName, eventData = {}) => {
      if (!enabled) return;
      try {
        sendGTMEvent(eventName, eventData);
      } catch (e) {
        // Silent fail - GTM should never break the enrollment flow
      }
    },
    [enabled]
  );

  const gtmFormSubmit = useCallback(
    (formName, additionalData = {}) => {
      if (!enabled) return;
      try {
        trackFormSubmit(formName, additionalData);
      } catch (e) {
        // Silent fail
      }
    },
    [enabled]
  );

  const gtmButtonClick = useCallback(
    (buttonName, additionalData = {}) => {
      if (!enabled) return;
      try {
        trackButtonClick(buttonName, additionalData);
      } catch (e) {
        // Silent fail
      }
    },
    [enabled]
  );

  const gtmError = useCallback(
    (errorMessage, additionalData = {}) => {
      if (!enabled) return;
      try {
        trackError(errorMessage, additionalData);
      } catch (e) {
        // Silent fail
      }
    },
    [enabled]
  );

  return {
    enabled,
    gtmEvent,
    gtmFormSubmit,
    gtmButtonClick,
    gtmError,
  };
};
